import {useParams} from "react-router-dom";
import history from "src/history";
import {parse} from "query-string";

export const getParamFromURL = (param: string) => {
    try {
        const params: any = useParams();
        return params ? params[param] : null;
    } catch (err) {
        console.log(err);
        return null;
    }
}

export const redirectToNotFound = () => {
    history.push("/notFound");
}

export const redirectToHomePage = () => {
    history.push("/");
}


const flows_regexp = {
    configPanel: /\/configPanel\/.*/,
    modelTraining: /\/modelTraining\/.*/,
    featureGeneration: /\/featureGeneration\/.*/
}

export const FLOWS = {
    CONFIG_PANEL: "configPanel",
    MODEL_TRAINING: "modelTraining",
    FEATURE_GENERATION: "featureGeneration"
}

export const getFlowFromURL = (pathname: string) => {
    let match = pathname.match(flows_regexp.configPanel);
    if ( match  && match[0] === pathname) {
        return FLOWS.CONFIG_PANEL;
    }

    match = pathname.match(flows_regexp.modelTraining);
    if ( match  && match[0] === pathname) {
        return FLOWS.MODEL_TRAINING;
    }

    match = pathname.match(flows_regexp.featureGeneration);
    if ( match  && match[0] === pathname) {
        return FLOWS.FEATURE_GENERATION;
    }

    return null;

}

export const matchURLRegex = (regex: string) => {
    const uri = window.location.pathname;
    return uri.match(regex)
}

export const removeTrailingSlashes = (path: string) => {
    return path.replace(/\/$/, "");
}

export const isAnchor = (event: any) => {
    try{
        if (event.target.href) {
            return true;
        }
        return false;
    } catch (error) {
        return false;
    }
}

export const getParamFromQueryString = (search: any, param: string) => {
    try {
        const params = parse(search);
        if (params && params[param]) {
            return params[param];
        }
        return null;
    } catch (error) {
        return null;
    }
}

export const setParamToQueryString = (paramName: string, paramValue: string | null) => {
    const params = new URLSearchParams(history.location.search);
    if (paramValue && params.has(paramName))
        params.set(paramName, paramValue);
    else if (paramValue)
        params.append(paramName, paramValue);
    else
        params.delete(paramName);
    let newLocation = {...history.location, search: params.toString()};
    history.replace(newLocation);
}

export const resetParamsQueryString = () => {
    const params = new URLSearchParams();
    let newLocation = {...history.location, search: params.toString()}
    history.replace(newLocation);
}
